const updateBackupStr = {
  toastr: 'Backup actualizado',
  toastrError: 'No se pudo actualizar lo backup'
};

export default updateBackupStr;
